
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5989_22)"}},[_c('path',{attrs:{"fill":"#000","d":"M7.67 7.416V5.611c0-.152.06-.266.2-.342l3.785-2.09c.516-.285 1.13-.418 1.764-.418 2.379 0 3.885 1.767 3.885 3.648 0 .133 0 .285-.02.437L13.36 4.642a.69.69 0 0 0-.714 0zm8.841 7.03v-4.313c0-.266-.119-.456-.357-.59L11.18 6.77l1.626-.893a.37.37 0 0 1 .396 0l3.786 2.09c1.09.608 1.824 1.9 1.824 3.154a3.58 3.58 0 0 1-2.3 3.325m-10.01-3.8-1.625-.912a.36.36 0 0 1-.198-.342v-4.18c0-2.033 1.625-3.572 3.825-3.572.833 0 1.606.266 2.26.741L6.858 4.547c-.237.133-.356.323-.356.59zM10 12.584 7.67 11.33V8.67L10 7.416l2.329 1.254v2.66zm1.496 5.776a3.8 3.8 0 0 1-2.26-.74l3.906-2.167c.237-.133.356-.323.356-.59v-5.51l1.646.913c.138.076.198.19.198.342v4.18c0 2.033-1.645 3.572-3.846 3.572M6.8 14.123l-3.786-2.09c-1.09-.608-1.824-1.9-1.824-3.154 0-1.463.912-2.774 2.32-3.325v4.332c0 .266.118.456.356.59L8.82 13.23l-1.625.893a.37.37 0 0 1-.396 0M6.58 17.24c-2.24 0-3.885-1.615-3.885-3.61 0-.152.02-.304.04-.456l3.904 2.166a.69.69 0 0 0 .714 0l4.975-2.755v1.805c0 .152-.06.266-.198.342l-3.786 2.09c-.516.285-1.13.418-1.764.418m4.915 2.261c2.399 0 4.4-1.634 4.857-3.8 2.22-.551 3.647-2.546 3.647-4.579 0-1.33-.595-2.622-1.665-3.553.1-.399.159-.798.159-1.197 0-2.717-2.3-4.75-4.956-4.75a4.9 4.9 0 0 0-1.566.247A5.08 5.08 0 0 0 8.503.5c-2.398 0-4.4 1.634-4.856 3.8C1.427 4.851 0 6.846 0 8.879c0 1.33.595 2.622 1.665 3.553-.1.399-.159.798-.159 1.197 0 2.717 2.3 4.75 4.956 4.75a4.9 4.9 0 0 0 1.566-.247 5.08 5.08 0 0 0 3.468 1.368"}})]),_c('defs',[_c('clipPath',{staticClass:"i-clip0_5989_22"},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    